import { render } from "./EditPriceQuoted.vue?vue&type=template&id=28f350ae&scoped=true"
import script from "./EditPriceQuoted.vue?vue&type=script&lang=js"
export * from "./EditPriceQuoted.vue?vue&type=script&lang=js"

import "./EditPriceQuoted.vue?vue&type=style&index=0&id=28f350ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f350ae"]])

export default __exports__